// extracted by mini-css-extract-plugin
export default {"main":"Gallery_main__dfZUH","no_img":"Gallery_no_img__lhpJh","container":"Gallery_container__pWJ6Z","column":"Gallery_column__SU98d"};